import { useEffect, useState } from "react";
import { fetchCurrentChannelInfo } from "../utils/twitchApi";
import useTwitchAuth from "./useTwitchAuth";
export default () => {
    const auth = useTwitchAuth();
    const [channelName, setChannelName] = useState();
    useEffect(() => {
        if (!auth)
            return;
        fetchCurrentChannelInfo(auth)
            .then((newChannelInfo) => {
            if (typeof (newChannelInfo === null || newChannelInfo === void 0 ? void 0 : newChannelInfo.broadcaster_login) === "string") {
                setChannelName(newChannelInfo.broadcaster_login.toLowerCase());
            }
        })
            .catch((e) => {
            console.error("Failed to fetch channel info", e);
            return undefined;
        });
    }, [auth]);
    return channelName;
};
